import * as React from "react";
import {api} from "../../../api";
import {AsyncSelect} from "./AsyncSelect";


export class PollingUnitPicker extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    loadOptions = (inputValue: string, callback: any) => {
        const filters = this.props.filters;
        // TODO min length, limit results in API
        inputValue && inputValue.length > 0 && api.pollingUnit.getListAction({
            page: 0,
            search: inputValue,
            filters: filters,
            limit:500
        }).then((response) => {
            callback(response.map((item: any) => ({
                value: item['id'],
                //TODO we need label direct from endpoint, that will also be used to fill values while editing
                label: ' (' + item['station_number'] + '), ' +  item['name'] + ', ' +  item['ward']['name'] + ', ' + item['local_government_area']['name'] + ', ' + item['state']['name'],
                id: item['id'],
            })));
        });
    };

    render() {
        const {multi= true, ...rest} = this.props;

        return (
            <AsyncSelect
                multi={multi}
                cacheOptions={true}
                loadOptions={this.loadOptions}
                placeholder="Search Polling Units ..."
                {...rest}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/PollingUnitPicker.tsx